<template>
  <div class="d-flex flex-row">
    <div class="d-flex flex-row style-vertical-scrolling mx-4 mt-4">
      <template v-for="card in populatedCardList" :key="card.id">
        <div
          class="style-card-container d-flex flex-row me-3 align-items-center justify-content-center scss-clickable scss-click-effect"
          :class="{
            'style-selected-card': selectedPaymentMethodId === card.id,
          }"
          @click="selectCard(card)"
        >
          <card-brand-icon v-if="card.cardBrand" :cardBrand="card.cardBrand" />
          <i v-else class="bi bi-credit-card-2-front-fill style-icon"></i>
          <span class="ms-2">{{ card.cardNumber }}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import CardBrandIcon from "@/components/onlinePayment/CardBrandIcon";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "CardList",
  components: { CardBrandIcon },
  emits: ["update:paymentMethodId"],
  props: { paymentMethodId: [String, Number] },
  computed: {
    populatedCardList() {
      const defaultCard = {
        id: 0,
        cardNumber: "One-Time",
      };

      if (this.cards === null) {
        return [defaultCard];
      }

      return [
        defaultCard,
        ...this.cards.map((card) => {
          return {
            id: card.id,
            cardNumber: `**** ${card.card.last4}`,
            cardBrand: card.card.brand,
          };
        }),
      ];
    },
    selectedPaymentMethodId: {
      set(value) {
        this.$emit("update:paymentMethodId", value);
      },
      get() {
        return this.paymentMethodId;
      },
    },
    ...mapGetters(["cards"]),
  },
  methods: {
    selectCard(card) {
      this.selectedPaymentMethodId = card.id;
    },
    ...mapActions(["getSavedCards"]),
  },
  created() {
    this.getSavedCards();
  },
};
</script>

<style lang="scss" scoped>
.style-vertical-scrolling {
  overflow-y: hidden;
  white-space: nowrap;
}
.style-card-container {
  min-width: 150px;
  height: 55px;
  border: 1px solid #d1d1d1;
}

.style-icon {
  font-size: 25px;
}

.style-selected-card {
  border: 2px solid #579eff;
  color: #579eff;
  font-weight: bold;
}
</style>
